import { useQuery } from '@tanstack/react-query';

import { ListMmaoOffersQuery, listMmaoOffers } from '~/services/AccommodationService';

export const mmaoOffersQueryKeys = {
  all: ['mmaoOffers'] as const,
  lists: () => [...mmaoOffersQueryKeys.all, 'list'] as const,
  list: (filters: ListMmaoOffersQuery) => [...mmaoOffersQueryKeys.lists(), filters] as const,
};

export function useGetMmaoOffers(params: ListMmaoOffersQuery) {
  return useQuery({
    queryKey: mmaoOffersQueryKeys.list(params),
    queryFn: async () => {
      const response = await listMmaoOffers(params);
      return response.result;
    },
  });
}
